import React, { useState, useEffect, useRef } from 'react';

function Counter({ end, duration }) {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && count === 0) {
          let startTime = null;
          const startTimestamp = Date.now();

          const animate = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const progress = Math.min((Date.now() - startTimestamp) / duration, 1);

            setCount(Math.floor(progress * end));

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };

          requestAnimationFrame(animate);
          observer.unobserve(countRef.current);
        }
      },
      { threshold: 0.5 }
    );

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => {
      if (countRef.current) {
        observer.unobserve(countRef.current);
      }
    };
  }, [end, duration, count]);

  return <h1 ref={countRef} className="display-4 text-white">{count}</h1>;
}

export default Counter;